import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import {Hint, HorizontalGridLines, VerticalBarSeries as BarSeries, VerticalGridLines, XAxis, XYPlot, YAxis,} from "react-vis/es/index";
import acc from 'accounting'
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import DlaJednejTrasyTabelaSzczegolowaTable from "./DlaJednejTrasyTabelaSzczegolowaTable";

export default class DlaJednejTrasyMiesiecznyChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ilevalue: null,
            wartvalue: null,
            daneDlaTrasyZnizki: [],
            daneDlaTrasyGeneral: [],
            daneDlaTrasySzczegoly: [],
            czyPokazacSzczegoly: true,
            czyPokazacSzczegolyWTabeli: true,
        };
        this._rememberValue = this._rememberValue.bind(this);
        this._forgetValue = this._forgetValue.bind(this);
    }

    componentWillReceiveProps(nextprops) {

        this.setState({
            daneDlaTrasyZnizki: nextprops.daneDlaTrasyZnizki,
            daneDlaTrasyGeneral: nextprops.daneDlaTrasyGeneral,
            daneDlaTrasySzczegoly: nextprops.daneDlaTrasySzczegoly,
        })
    }

    _forgetValue(typ) {
        if (typ === 'ile') this.setState({ilevalue: null});
        else this.setState({wartvalue: null});
    }

    _rememberValue(value, typ) {
        if (typ === 'ile') this.setState({ilevalue: value});
        else this.setState({wartvalue: value});

    }

    renderHint(obj) {
        return (
            <div className="CHARTtooltip">
                <span className="tooltiptext">
                <div>Zniżka: {obj.rodz}</div>
                <div>Ilość: {obj.ile}</div>
                <div>Wartość: {acc.formatMoney(obj.wart)}</div>
                </span>
            </div>
        )
    }

    obliczSumeWTabeli(arr, key) {
        let suma = 0;
        for (let i = 0; i < arr.length; i++) {
            suma = suma + arr[i][key]
        }
        return suma
    }

    renderZnizkiLabels() {
        return (
            this.state.daneDlaTrasyZnizki.map((item, index) => {
                if (item.length>0) {
                    return <span className={'label label-ebus-default'}
                                 style={{color: '#fff', background: item[0].kolor, marginRight: '5px'}}>{item[0].rodz}</span>
                }
            })
        )
    }

    renderOkres(cell, row) {
        if (cell === 'P1') {
            return 'I połowa'
        }
        else if (cell === 'P2') {
            return 'II połowa'
        }
        else if (cell === 'M1') {
            return 'cały miesiąc'
        }
        else return cell
    }

    renderWLiscie(arr, znizka, naz_zniz, kolor) {
        return <div className={'renderowanaListaSzegolowRaportowBiletowychSprzedazy'}>
            <div>
                {
                    (znizka === 'OGÓŁEM') ?
                        <div style={{fontWeight: 'bold', fontSize: '16px'}}>OGÓŁEM</div>
                        :
                        <div><span className={'label label-ebus-default'} style={{background: kolor, color: '#fff'}}>{znizka}</span><span
                            style={{marginLeft: '3px', fontSize: '10px', color: 'grey', fontStyle: 'italic'}}>{naz_zniz}</span></div>

                }
            </div>
            <div className={(znizka === 'OGÓŁEM') ? 'tabelaOgolem' : ''}>
                <BootstrapTable data={arr}
                                hover
                >
                    <TableHeaderColumn dataField='idKi' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='okres' dataSort
                                       thStyle={tabgrid.tg10} tdStyle={tabgrid.tg10}
                                       dataFormat={this.renderOkres}
                    ><i className={'fa fa-adjust'}></i> Okres</TableHeaderColumn>
                    <TableHeaderColumn dataField='ile' dataSort
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                    ><i className={'fa fa-tags'}></i> Ilość</TableHeaderColumn>
                    <TableHeaderColumn dataField='wart' dataSort
                                       thStyle={tabgrid.tg8} tdStyle={tabgrid.tg8}
                                       dataFormat={(cell, row) => {
                                           return acc.formatMoney(cell)
                                       }}
                    ><i className={'fa fa-money'}></i> Wartość</TableHeaderColumn>
                </BootstrapTable>
            </div>
            <div className={'podsumowanieTr'}>
                <div className={'podsumowanieTd'} style={{width: '40%'}}>PODSUMOWANIE:</div>
                <div className={'podsumowanieTd'} style={{width: '28%'}}>{this.obliczSumeWTabeli(arr, 'ile')}</div>
                <div className={'podsumowanieTd'} style={{width: '32%'}}>{acc.formatMoney(this.obliczSumeWTabeli(arr, 'wart'))}</div>
            </div>
        </div>
    }

    formatLabelX(label) {
        if (label === 'P1') {
            return 'I połowa'
        }
        else if (label === 'P2') {
            return 'II połowa'
        }
        else if (label === 'M1') {
            return 'cały miesiąc'
        }
        else return label
    }

    render() {

        if (this.state.daneDlaTrasyGeneral.length == 0)
            return <TopAlertUwaga text={'Brak danych spełniających podane kryterium'}/>
        else
            return (
                <div style={{marginTop: '25px'}}>

                    <div>
                        <div>
                            <Row>
                                <Col xs={12}>
                                    <div>
                                        <div className={'pull-right'} style={{margin: '5px'}}>
                                            <span style={{marginRight: '5px'}}>Legenda zniżek: </span>
                                            {this.renderZnizkiLabels()}
                                        </div>
                                        <div style={{height: '1px', clear: 'both'}}></div>
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div>
                                        <h4 style={{textAlign: 'center'}}>Sprzedaż ilościowa</h4>
                                    </div>
                                    <XYPlot width={800} height={400} stackBy="y" xType="ordinal">
                                        <VerticalGridLines/>
                                        <HorizontalGridLines/>
                                        <XAxis tickFormat={this.formatLabelX}/>
                                        <YAxis title={'Ilość'}/>

                                        {this.state.ilevalue ? <Hint value={this.state.ilevalue}>{this.renderHint(this.state.ilevalue)}</Hint> : null}

                                        {
                                            this.state.daneDlaTrasyZnizki.map((arr, index) => {

                                                if(arr.length>0) {

                                                    return <BarSeries data={Array.from(arr, item => {
                                                        return {...item, x: item.okres, y: item.ile}
                                                    })}
                                                                      onValueMouseOver={(val) => this._rememberValue(val, 'ile')}
                                                                      onValueMouseOut={() => this._forgetValue('ile')}
                                                                      color={arr[0].kolor}
                                                    />
                                                }
                                            })
                                        }

                                    </XYPlot>
                                </Col>
                                <Col xs={6}>
                                    <div>
                                        <h4 style={{textAlign: 'center'}}>Sprzedaż wartościowa</h4>
                                    </div>
                                    <div>
                                        <XYPlot width={800} height={400} stackBy="y" xType="ordinal" yType={'linear'}>
                                            <VerticalGridLines/>
                                            <HorizontalGridLines/>
                                            <XAxis tickFormat={this.formatLabelX}/>
                                            <YAxis title={'Wartość [zł]'}/>
                                            {this.state.wartvalue ?
                                                <Hint value={this.state.wartvalue}>{this.renderHint(this.state.wartvalue)}</Hint> : null}
                                            {
                                                this.state.daneDlaTrasyZnizki.map((arr, index) => {
                                                    if(arr.length>0) {
                                                        return <BarSeries data={Array.from(arr, item => {
                                                            return {...item, x: item.okres, y: item.wart}
                                                        })}
                                                                          onValueMouseOver={(val) => this._rememberValue(val, 'wart')}
                                                                          onValueMouseOut={() => this._forgetValue('wart')}
                                                                          color={arr[0].kolor}
                                                        />
                                                    }
                                                })
                                            }
                                        </XYPlot>
                                    </div>
                                </Col>
                            </Row>

                        </div>

                        <div>
                            <div className={'pull-right'}>
                                <TopButtonAction text={(this.state.czyPokazacSzczegoly) ? 'Ukryj szczegóły' : 'Pokaż szczegóły'}
                                                 iconType={(this.state.czyPokazacSzczegoly) ? 'fa fa-eye-slash' : 'fa fa-eye'}
                                                 onClick={() => this.setState({czyPokazacSzczegoly: !this.state.czyPokazacSzczegoly})}/>
                            </div>
                        </div>
                        <div style={{height: '1px', clear: 'both'}}></div>
                        <TopIf isTrue={this.state.czyPokazacSzczegoly}>
                            <div>
                                <Row>
                                    <Col xs={6} lg={3}>
                                        {this.renderWLiscie(this.state.daneDlaTrasyGeneral, 'OGÓŁEM', '#000')}
                                    </Col>
                                    {
                                        this.state.daneDlaTrasyZnizki.map((arr, index) => {
                                            if(arr.length>0) {
                                                return <Col xs={6} lg={3}>{this.renderWLiscie(arr, arr[0].rodz, arr[0].naz_zniz, arr[0].kolor)}</Col>
                                            }
                                        })
                                    }
                                </Row>
                            </div>
                        </TopIf>
                    </div>
                    <div>
                        <div className={'pull-right'}>
                            <TopButtonAction text={(this.state.czyPokazacSzczegolyWTabeli) ? 'Ukryj szczegółową tabelę' : 'Pokaż szczegółową tabelę'}
                                             iconType={(this.state.czyPokazacSzczegolyWTabeli) ? 'fa fa-eye-slash' : 'fa fa-eye'}
                                             onClick={() => this.setState({czyPokazacSzczegolyWTabeli: !this.state.czyPokazacSzczegolyWTabeli})}/>
                        </div>
                    </div>
                    <div>
                        <TopIf isTrue={this.state.czyPokazacSzczegolyWTabeli}>
                            <Row>
                                <Col xs={12}>
                                    <div style={{fontWeight: 'bold', fontSize: '16px'}}>
                                        SZCZEGÓŁOWE ZESTAWIENIE
                                    </div>
                                    <DlaJednejTrasyTabelaSzczegolowaTable data={this.state.daneDlaTrasySzczegoly}/>
                                </Col>
                            </Row>
                        </TopIf>
                    </div>

                </div>
            );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazMiesiecznych/components/DlaJednejTrasyMiesiecznyChart.js